import { getFieldTitle } from '@src/utils/fieldDefinitionUtils';
import { fixedRateLoanFieldDefinitions } from '@src/utils/OTC/fixedRateLoanFieldDefinitions';
import { formatDayCountConvention, formatPaymentPeriod } from '@src/utils/OTC/otcUtils';
import type { OTCFixedRateLoanProductDetails } from '@talos/kyoko';
import type { ReactNode } from 'react';
import { InspectorText } from '../InspectorText';

type ScheduleSource = Pick<OTCFixedRateLoanProductDetails, 'AccrualPeriod' | 'PaymentPeriod' | 'DayCountConvention'>;

/**
 * Accrual Period, Payment Period, Day Count Convention — appended at bottom of Deal Information for loan products.
 */
export function buildLoanScheduleDealInformationFields(productDetails: ScheduleSource): Array<{
  fieldName: string;
  fieldValue: ReactNode;
}> {
  const accrualLabel = formatPaymentPeriod(productDetails.AccrualPeriod) || '-';
  const paymentLabel = formatPaymentPeriod(productDetails.PaymentPeriod) || '-';
  const dayCountLabel = formatDayCountConvention(productDetails.DayCountConvention) || '-';

  return [
    {
      fieldName: getFieldTitle(fixedRateLoanFieldDefinitions.accrualPeriod),
      fieldValue: <InspectorText>{accrualLabel}</InspectorText>,
    },
    {
      fieldName: getFieldTitle(fixedRateLoanFieldDefinitions.paymentPeriod),
      fieldValue: <InspectorText>{paymentLabel}</InspectorText>,
    },
    {
      fieldName: getFieldTitle(fixedRateLoanFieldDefinitions.dayCountConvention),
      fieldValue: <InspectorText>{dayCountLabel}</InspectorText>,
    },
  ];
}
